import React from 'react';
import { Award, Target, TrendingUp, Heart } from 'lucide-react';
import { aboutData } from '../utils/mockData';

const About = () => {
  const iconMap = {
    0: Target,
    1: TrendingUp,
    2: Heart,
    3: Award
  };

  return (
    <section id="about" className="section-padding">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="section-title">About Me</h2>
          <div className="section-title-underline"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start mb-16">
          <div className="about-image-container">
            <img 
              src="https://customer-assets.emergentagent.com/job_e62ce57c-3c16-45b9-ad98-384d5c2e55e7/artifacts/dhq3wh3j_IMG_3449.JPG"
              alt="Aaron Choi personal trainer working with client in Hampshire gym"
              className="about-image"
            />
          </div>
          
          <div className="about-content">
            <h3 className="about-name">{aboutData.name}</h3>
            <p className="about-experience">{aboutData.experience} • {aboutData.clientsHelped}</p>
            <div className="about-story">
              {aboutData.story.split('\n\n').map((paragraph, index) => (
                <p key={index} className="about-paragraph">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="credentials-card">
            <h3 className="credentials-title">Specialist Areas</h3>
            <div className="credentials-grid">
              {aboutData.specialistAreas.map((area, index) => {
                const Icon = iconMap[index];
                return (
                  <div key={index} className="credential-item">
                    <Icon className="credential-icon" />
                    <span>{area}</span>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="credentials-card">
            <h3 className="credentials-title">Qualifications</h3>
            <div className="credentials-list">
              {aboutData.qualifications.map((qual, index) => (
                <div key={index} className="qualification-item">
                  <Award className="qualification-icon" />
                  <span>{qual}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
